module.exports = __webpack_public_path__ + "static/media/Tripmanagment.3bffe856.svg";